/* eslint-disable no-useless-escape */
const REGEX = {
  URL: /^https?:\/\/(?:(?:[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?\.)+[A-Z]{2,}|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/?|[\/?]\S*)$/i,
  EMAIL: /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
  MOBILE_NO: /^\+\d{12}$/, // number (min/max 10) without spaces allowing heading & trailing whitespaces.
  ALPHA_NUMERIC_WITHOUT_SPACES: /^[ ]*[a-zA-Z0-9]+[ ]*$/, // without space in between
  ALPHA_NUMERIC_WITH_SPACES: /^[a-zA-Z0-9\s]+$/,
  ALPHA_WITH_SPACES: '^[A-Za-z]+[A-Za-z ]*$', //  alphabets with or without space
  NO_SPACE_IN_START_AND_END: /^\S(?:.*\S)?$/,
  ALPHA_NUMERIC_WITHOUT_SPECIAL_CHARACTERS: '^[a-zA-Z0-9 ]*$', // alphanumeric without special chars
  USERNAME: /^(?![^a-zA-Z0-9]*$)[a-zA-Z0-9._%+-@]{1,320}$/,
  DISPLAY_NAME: /^[a-zA-Z][a-zA-Z0-9_-]+$/,
  ORGANIZATION_ID: /^(?!pg_|PG_)[a-zA-Z][a-zA-Z0-9_-]+$/,
  ORGANIZATION_NAME: /^[a-zA-Z][a-zA-Z0-9_-]*(?:\s[a-zA-Z0-9_-]+)*$/,
  PASSWORD: /^(?=.*[a-zA-Z])(?!.*\s).{8,15}$/,
  ONLY_NUMBER: /^-?\d+$/,
  CAMELCASE_PATTERN: /([a-z])([A-Z])/g,
  NO_SPACE: '^\S+$',
  HEX_REGEX: /^#([\da-f]{3}){1,2}$/i,
  RGB_REGEX:
    /^rgb\((((((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5]),\s?)){2}|((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5])\s)){2})((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5]))|((((([1-9]?\d(\.\d+)?)|100|(\.\d+))%,\s?){2}|((([1-9]?\d(\.\d+)?)|100|(\.\d+))%\s){2})(([1-9]?\d(\.\d+)?)|100|(\.\d+))%))\)$/i,
  RGBA_REGEX:
    /^rgba\((((((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5]),\s?)){3})|(((([1-9]?\d(\.\d+)?)|100|(\.\d+))%,\s?){3}))|(((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5])\s){3})|(((([1-9]?\d(\.\d+)?)|100|(\.\d+))%\s){3}))\/\s)((0?\.\d+)|[01]|(([1-9]?\d(\.\d+)?)|100|(\.\d+))%)\)$/i,
  HSL_REGEX:
    /^hsl\(((((([12]?[1-9]?\d)|[12]0\d|(3[0-5]\d))(\.\d+)?)|(\.\d+))(deg)?|(0|0?\.\d+)turn|(([0-6](\.\d+)?)|(\.\d+))rad)((,\s?(([1-9]?\d(\.\d+)?)|100|(\.\d+))%){2}|(\s(([1-9]?\d(\.\d+)?)|100|(\.\d+))%){2})\)$/i,
  HSLA_REGEX:
    /^hsla\(((((([12]?[1-9]?\d)|[12]0\d|(3[0-5]\d))(\.\d+)?)|(\.\d+))(deg)?|(0|0?\.\d+)turn|(([0-6](\.\d+)?)|(\.\d+))rad)(((,\s?(([1-9]?\d(\.\d+)?)|100|(\.\d+))%){2},\s?)|((\s(([1-9]?\d(\.\d+)?)|100|(\.\d+))%){2}\s\/\s))((0?\.\d+)|[01]|(([1-9]?\d(\.\d+)?)|100|(\.\d+))%)\)$/i,
  COLOR_REGEX: /^color\(([^()]+)\)$/,
};
export default REGEX;
